module.exports = __webpack_public_path__ + "fonts/FontsFree-Net-Acumin-Pro-Light.9ee3dbf.ttf";